import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'shadcn/components/ui/tooltip';
import {
    COMPANY_SOURCE_BADGE_ABBREVIATIONS,
    COMPANY_SOURCE_BADGE_COLORS,
    getCompanySourceById,
} from 'shared/companySource';

/**
 * @param {Object} props
 * @param {number[]} props.companySourceIds
 * @returns {JSX.Element|null}
 */
export function CompanySourceBadge({ companySourceIds }) {
    const companySources = companySourceIds.map(getCompanySourceById).filter(Boolean);

    if (companySources.length === 0) return null;

    return (
        <span className="inline-flex items-center gap-0.5">
            {companySources.map((companySource) => {
                const abbreviation =
                    COMPANY_SOURCE_BADGE_ABBREVIATIONS[companySource.code] ??
                    companySource.displayName.slice(0, 2).toUpperCase();
                const badgeColor = COMPANY_SOURCE_BADGE_COLORS[companySource.code] ?? '#6B7280';

                return (
                    <Tooltip key={companySource.id}>
                        <TooltipTrigger asChild>
                            <span
                                className="inline-flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-[3px] px-[3px] text-[9px] font-bold leading-none text-white"
                                style={{ backgroundColor: badgeColor }}
                                aria-label={companySource.displayName}
                            >
                                {abbreviation}
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>{companySource.displayName}</TooltipContent>
                    </Tooltip>
                );
            })}
        </span>
    );
}
